import { Component, Input } from '@angular/core'

@Component({
    selector: 'app-skeleton-list',
    templateUrl: './skeleton-list.component.html',
    styleUrls: ['./skeleton-list.component.scss'],
})
export class SkeletonListComponent {
    //default values
    @Input() items = 3
    @Input() itemHeight = 48 // px

    get itemArray(): number[] {
        return Array(this.items).fill(0)
    }
}
